import { FormInstance } from 'antd/lib/form';
import React, { ReactElement } from 'react';
import ClientFormHeader from '../../../components/Client/ClientFormHeader';
import ClosingToolFormSection from '../../../components/Feature/OnDemand/ClosingToolFormSection';
import FullEtaFormSection from '../../../components/Feature/OnDemand/FullEtaFormSection';
import PreparationTimeFormSection from '../../../components/Feature/OnDemand/PreparationTimeFormSection';
import { CLIENT_STATUS } from '../../../types/Client';
import ClientForm from '../ClientForm';
import { useClientFormContext } from '../ClientFormContext';
import {
    submitClosingToolConfigFactory,
    submitFullEtaConfigFactory,
    submitPreparationTimeConfigFactory,
} from '../utils/submit';

const ClientOnDemandForm: React.FC = (): React.ReactElement => {
    const { client, data, formConfig, setData } = useClientFormContext();

    const submitForm = async (form: FormInstance): Promise<void> => {
        if (!client) return;

        Promise.allSettled([
            submitFullEtaConfigFactory(client.id, data.fullEta)(form),
            submitPreparationTimeConfigFactory(client.id, data.preparationTime)(form),
            submitClosingToolConfigFactory(client.id, data.closingTool)(form),
        ]).then(([fullEtaRes, preparationTimeRes, closingToolRes]) => {
            const newData = { ...data };
            if (fullEtaRes.status === 'fulfilled') newData.fullEta = fullEtaRes.value;
            if (preparationTimeRes.status === 'fulfilled') newData.preparationTime = preparationTimeRes.value;
            if (closingToolRes.status === 'fulfilled') newData.closingTool = closingToolRes.value;
            setData(newData);
        });
    };

    return (
        <>
            <div className="shadow-sm pb-4">
                <ClientFormHeader />
                <div className="px-4">
                    <ClientForm name="onDemand" submitForm={submitForm}>
                        {({ form }): ReactElement => (
                            <>
                                <FullEtaFormSection
                                    formInstance={form}
                                    fullEtaConfig={data.fullEta}
                                    enableControls={client?.status !== CLIENT_STATUS.DELETED}
                                    isDetailMode={formConfig.isDetailMode}
                                />
                                <PreparationTimeFormSection
                                    formInstance={form}
                                    preparationTimeConfig={data.preparationTime}
                                    enableControls={client?.status !== CLIENT_STATUS.DELETED}
                                    isDetailMode={formConfig.isDetailMode}
                                />
                                <ClosingToolFormSection
                                    formInstance={form}
                                    closingToolConfig={data.closingTool}
                                    enableControls={client?.status !== CLIENT_STATUS.DELETED}
                                    isDetailMode={formConfig.isDetailMode}
                                />
                            </>
                        )}
                    </ClientForm>
                </div>
            </div>
        </>
    );
};

export default ClientOnDemandForm;
